import { render, staticRenderFns } from "./reservation-order.vue?vue&type=template&id=7156bf4f&scoped=true&"
import script from "./reservation-order.vue?vue&type=script&lang=js&"
export * from "./reservation-order.vue?vue&type=script&lang=js&"
import style0 from "./reservation-order.vue?vue&type=style&index=0&id=7156bf4f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7156bf4f",
  null
  
)

export default component.exports